export default __webpack_public_path__ + "static/media/Komikula.5ac384e0.otf";